import {environment} from '../../environments/environment';

export const API_URL = environment.baseUrl ? `${environment.baseUrl}` : `${window.location.origin}`;

export const API_ENDPOINT = {
  //
  // Base
  Auth: 'api/auth',

  //
  //
  Dashboard: 'api/dashboard',

  //
  // Notification
  Notification: 'api/notifications',

  Erp: 'api/erp',

  Statement: 'api/statement',

  Matching: 'api/matching',

  //
  // Setting
  Email: 'api/email',

  //
  // Setting
  Setting: 'api/settings',

  // Vendor
  Vendor: 'api/vendor',

  // Organizations
  Organizations: 'api/organizations',

  // Audit
  Audit: 'api/audit'
};
